"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./CustomPasswordInput.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _FormField = _interopRequireDefault(require("../../mixins/FormField"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _Tooltip = _interopRequireDefault(require("../tooltip/Tooltip"));

var _SharedContent = require("../../../shared/components/cms/SharedContent");

var sentinel = _interopRequireWildcard(require("@sentinel/utils"));

var _keys = _interopRequireDefault(require("lodash/keys"));

var _class, _class2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var SharedKey = "customPasswordInput";
var SharedItem = (0, _SharedContent.SharedContentItem)(SharedKey);
var CustomPasswordInput = (_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomPasswordInput, _React$Component);

  var _super = _createSuper(CustomPasswordInput);

  function CustomPasswordInput(props) {
    _classCallCheck(this, CustomPasswordInput);

    return _super.call(this, props);
  }

  _createClass(CustomPasswordInput, [{
    key: "handleEnter",
    value: function handleEnter(e) {
      if (e.key === "Enter") {
        this.value = this.inputElement.value;
        this.updateBackingValue(true);
        this.inputElement.select();

        if (!(0, _isUndefined.default)(this.props.onBlur)) {
          this.props.onBlur();
        }
      }
    }
  }, {
    key: "renderRequirements",
    value: function renderRequirements() {
      var _this$props$email,
          _this$props$firstName,
          _this$props$lastName,
          _this = this;

      var value = this.readValue() || "";
      var contextWords = [(_this$props$email = this.props.email) === null || _this$props$email === void 0 ? void 0 : _this$props$email.toLowerCase(), (_this$props$firstName = this.props.firstName) === null || _this$props$firstName === void 0 ? void 0 : _this$props$firstName.toLowerCase(), (_this$props$lastName = this.props.lastName) === null || _this$props$lastName === void 0 ? void 0 : _this$props$lastName.toLowerCase()].filter(Boolean);
      var schema = sentinel.validatePassword(contextWords);
      var errorMessages = [];

      try {
        schema.validateSync(value, {
          abortEarly: false
        });
      } catch (validationError) {
        errorMessages = validationError.errors || [];
      }

      var errorKeys = (0, _keys.default)(sentinel.passwordErrorMsg).filter(function (key) {
        return errorMessages.includes(sentinel.passwordErrorMsg[key]);
      });
      var hasRequired = errorKeys.includes("required");
      var allKeys = (0, _keys.default)(sentinel.passwordErrorMsg).filter(function (k) {
        return k !== "required";
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "input-message"
      }, /*#__PURE__*/_react.default.createElement(SharedItem, {
        contentKey: "passwordRequirementSubheader",
        className: "password-requirements-subheader"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "password-requirements"
      }, allKeys.map(function (key) {
        var valid = hasRequired ? false : !errorKeys.includes(key);
        return /*#__PURE__*/_react.default.createElement("div", {
          key: key
        }, _this.getValidationSpan(sentinel.passwordErrorMsg[key], valid));
      })));
    }
  }, {
    key: "getValidationSpan",
    value: function getValidationSpan(msg, valid, example) {
      var className = valid ? "valid-message" : "";

      if (!valid && !(0, _isEmpty.default)(this.getErrors())) {
        className = "invalid-message";
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "validation-message"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "checkmark-container"
      }, valid && /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-ok"
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: className,
        key: msg
      }, msg), example && /*#__PURE__*/_react.default.createElement(_Tooltip.default, null, /*#__PURE__*/_react.default.createElement("span", {
        className: "example"
      }, example)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fieldName = _this$props.fieldName,
          label = _this$props.label,
          id = _this$props.id,
          name = _this$props.name;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassNames("custom-input")
      }, !(0, _isEmpty.default)(label) && /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: fieldName
      }, label), /*#__PURE__*/_react.default.createElement("input", _extends({
        type: "password",
        id: id || fieldName,
        name: name || fieldName,
        ref: this.setInputRef,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyDown: this.handleEnter
      }, this.getInnerInputProps(), {
        autoComplete: "off"
      })), this.props.showErrors && this.renderErrors(), this.props.showRequirements && this.renderRequirements());
    }
  }]);

  return CustomPasswordInput;
}(_react.default.Component), _defineProperty(_class2, "propTypes", {
  disabled: _propTypes.default.bool,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  showRequirements: _propTypes.default.bool,
  showErrors: _propTypes.default.bool,
  email: _propTypes.default.string,
  firstName: _propTypes.default.string,
  lastName: _propTypes.default.string
}), _defineProperty(_class2, "defaultProps", {
  disabled: false,
  showRequirements: true,
  showErrors: true
}), _class2), (_applyDecoratedDescriptor(_class.prototype, "handleEnter", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnter"), _class.prototype)), _class);

var _default = (0, _FormField.default)(CustomPasswordInput);

exports.default = _default;